const LOGO = {
  LOGO_S: 74,
};

export default LOGO;
